export const propMisc = {
  // valoracionHuespedes.vue
  reviews: {
    title: "Avaliações dos hóspedes",
    subtitle: "Peça uma avaliação pelo WhatsApp no dia do check-out. Defina o link onde você quer que os hóspedes deixem o feedback.",
    bulkNotice: "Esta alteração será aplicada a todas as {count} acomodações vinculadas a este anúncio.",
    enableTitle: "Ativar avaliações dos hóspedes",
    enableSub: "Uma mensagem de WhatsApp é enviada automaticamente no dia do check-out pedindo uma avaliação.",
    modeSingleTitle: "Um único link",
    modeSingleSub: "O mesmo para todas as reservas",
    modePerOtaTitle: "Um link por OTA",
    modePerOtaSub: "Com base no canal da reserva",
    linkLabel: "Link de avaliação",
    singleUrlPlaceholder: "https://g.page/r/… ou o link da sua página de avaliações",
    otaNamePlaceholder: "Nome do site",
    otaUrlPlaceholder: "https://… link de avaliação",
    removeTitle: "Remover",
    addOta: "Adicionar outro site",
    saving: "Salvando…",
    saveConfig: "Salvar configurações",
    note: "Os hóspedes receberão o link correspondente com base em como reservaram.",
    toastLoadError: "Não foi possível carregar os dados do anúncio.",
    urlErrorProtocol: "A URL deve começar com http:// ou https://",
    urlErrorInvalid: "Insira uma URL válida (ex.: https://g.page/...)",
    toastStateUpdated: "Status atualizado com sucesso",
    toastStateError: "Algo deu errado ao atualizar o status",
    toastUrlRequired: "Insira uma URL antes de salvar",
    toastSaved: "Configurações salvas com sucesso",
    toastSaveError: "Algo deu errado ao salvar",
  },

  // AccessSummary.vue
  access: {
    tag: "Fechaduras e acesso",
    dynamicTitle: "Fechadura inteligente conectada",
    dynamicDetail: "Cada reserva gera um novo código automaticamente e o envia ao hóspede.",
    chipCheckin: "Enviado quando o check-in é concluído",
    chipTime: "Enviado às {time} no dia da chegada",
    chipManual: "Você envia manualmente",
    staticTitle: "Fechadura com código fixo",
    staticDetail: "O hóspede recebe o código do cofre de chaves ou da fechadura para entrar.",
    noneTitle: "Eu entrego as chaves pessoalmente",
    noneDetail: "Você combina a entrega das chaves com o hóspede na chegada.",
  },

  // ButtonUpdatePropertyPrice.vue
  updatePrice: {
    update: "Atualizar preço",
    saving: "Salvando…",
  },

  // MossosConnections.vue
  mossos: {
    intro: "Vincule cada unidade deste anúncio ao seu estabelecimento nos Mossos (cada unidade pode ter seu próprio ID policial). Os check-ins são enviados automaticamente ao estabelecimento correto com base na unidade da reserva.",
    wholeListing: "Anúncio inteiro",
    wholeListingDefault: "Anúncio inteiro (padrão)",
    unitNumber: "Unidade nº {id}",
    badgeSendError: "Erro no envio",
    badgeConnected: "Conectado",
    badgeNoCredentials: "Sem credenciais",
    emptyList: "Ainda não há conexões. Adicione uma para cada unidade do anúncio.",
    addConnection: "Adicionar conexão",
    editConnection: "Editar conexão",
    newConnection: "Nova conexão",
    unit: "Unidade",
    unitPlaceholder: "Escolha a unidade",
    unitHint: "A qual unidade do anúncio este estabelecimento pertence.",
    step1Title: "Acesso ao site dos Mossos",
    usuariLabel: "Usuari (site dos Mossos)",
    savedHint: "salvo",
    usuariPlaceholderKeep: "Deixe em branco para manter sem alterações",
    usuariPlaceholderNew: "Nome de usuário de login do site",
    passLabel: "Paraula de pas",
    passBlankHint: "em branco para manter sem alterações",
    passPlaceholder: "Senha do site dos Mossos",
    validateHint: "Valide para buscar os estabelecimentos da sua conta.",
    searching: "Buscando…",
    validateSearch: "Validar e buscar estabelecimentos",
    step2Title: "Estabelecimento para esta unidade",
    establishmentPlaceholder: "Selecione o estabelecimento",
    revalidateHint: "Valide novamente para alterá-lo.",
    validateAbove: "Valide acima para escolher o estabelecimento desta unidade.",
    checkinTime: "Horário de faturamento (chegada)",
    checkoutTime: "Horário de saída",
    cancel: "Cancelar",
    savingBtn: "Salvando...",
    updateConnection: "Atualizar conexão",
    saveConnection: "Salvar conexão",
    warnCredentials: "Insira o usuari e a paraula de pas do site dos Mossos.",
    foundEstablishments: "{count} estabelecimento(s) encontrado(s). Escolha o desta unidade.",
    noEstablishments: "Nenhum estabelecimento encontrado nesta conta.",
    connectError: "Não foi possível conectar aos Mossos. Verifique seu usuari e senha.",
    validateFirst: "Valide e escolha o estabelecimento para esta conexão.",
    savedOk: "Conexão com os Mossos salva.",
    saveError: "Não foi possível salvar a conexão.",
    saveErrorGeneric: "Erro ao salvar a conexão com os Mossos.",
    confirmDelete: `Excluir a conexão de "{unit}" ({id})?`,
    deletedOk: "Conexão excluída.",
    deleteError: "Não foi possível excluir a conexão.",
  },

  // SesAccounts.vue + modalPoliceData.vue — varias cuentas de SES por anuncio
  ses: {
    intro: "Cada unidade comunica seus hóspedes com uma conta do SES Hospedajes. Você pode usar uma só para o anúncio inteiro ou colocar uma diferente em algumas unidades, por exemplo se cada apartamento tem seu próprio código de estabelecimento.",
    defaultName: "Estabelecimento {code}",
    badgeConnected: "Conectada",
    badgeError: "Erro de validação",
    badgePending: "Sem validar",
    user: "Usuário",
    lessor: "Proprietário",
    establishment: "Estabelecimento",
    appliesWhole: "Anúncio inteiro:",
    appliesUnits: "Unidades:",
    noUnits: "Nenhuma unidade a usa",
    allUnits: "Todas as unidades ({count})",
    moreUnits: "+{count} mais",
    andMore: "e mais {count}",
    emptyList: "Você ainda não conectou nenhuma conta do SES Hospedajes.",
    withoutAccountTitle: "Sem conta:",
    withoutAccountText: "Seus check-ins não são comunicados ao SES Hospedajes.",
    addAccount: "Adicionar conta",
    edit: "Editar",
    remove: "Remover",
    newTitle: "Nova conta do SES Hospedajes",
    editTitle: "Editar conta do SES Hospedajes",
    aliasLabel: "Nome da conta (opcional)",
    aliasPlaceholder: "Ex.: Coberturas, Apartamento 2B",
    aliasHint: "Serve apenas para reconhecê-la aqui. Se ficar vazio, ela é mostrada pelo código do estabelecimento.",
    loginTitle: "Acesso ao Ministério",
    loginSame: "O mesmo usuário e senha",
    loginSameHint: "Você só escreve os códigos desta conta.",
    loginOwn: "Outro usuário e senha",
    loginFrom: "Usar o acesso de",
    passwordKeep: "Deixe vazia para não alterar",
    passwordNeeded: "Escreva a senha do novo usuário.",
    passwordShared: "Outras contas do anúncio usam este usuário ({count}): se você alterar a senha, ela é atualizada em todas.",
    scopeTitle: "A quais unidades se aplica?",
    scopeWhole: "Anúncio inteiro",
    scopeWholeHint: "É usada pelas unidades que não têm outra conta.",
    scopeWholeTaken: "«{name}» já é.",
    scopeUnits: "Só algumas unidades",
    scopeUnitsHint: "Você escolhe quais.",
    unitNow: "agora: {name}",
    unitNowWhole: "agora: a do anúncio inteiro",
    unitNowNone: "sem conta",
    leftWithout: "sem conta ao salvar. Seus check-ins deixarão de ser comunicados ao SES Hospedajes.",
    leftToWhole: "ao salvar, a comunicação passa a ser feita com a conta do anúncio inteiro «{name}».",
    errUnits: "Escolha pelo menos uma unidade.",
    errDefaultExists: "Este anúncio já tem uma conta para todas as suas unidades.",
    errDuplicate: "Você já tem essa conta neste anúncio. Edite-a e adicione unidades.",
    errCopyFrom: "Não foi possível usar o acesso dessa conta. Escreva-o manualmente.",
    savedValidated: "Conta salva e validada pelo Ministério.",
    savedNotValidated: "Salva, mas o Ministério não aceita os dados. Revise-os.",
    savedUnchecked: "Conta guardada. O TRA não permite verificar o token antecipadamente: saber-se-á no primeiro envio.",
    passwordSynced: "Senha atualizada também em {count} conta(s) com o mesmo usuário.",
    removeTitle: "Remover esta conta?",
    removeNoUnits: "A conta «{name}» será removida. Nenhuma unidade a está usando.",
    removeToFallback: "«{name}» será removida. As unidades que a usam ({units}) passarão a comunicar com a conta do anúncio inteiro «{fallback}».",
    removeToNothing: "«{name}» será removida. As unidades que a usam ({units}) ficarão sem conta e seus check-ins deixarão de ser comunicados ao SES Hospedajes.",
    removeConfirm: "Sim, remover",
    removed: "Conta removida.",
    removeError: "Não foi possível remover a conta.",
  },

  // Colombia — varias cuentas de SIRE y de TRA por anuncio (ColombiaAccounts.vue,
  // ColombiaAccountModal.vue y el aviso de cuentas de otro país en Autoridades.vue).
  co: {
    loading: "Carregando as contas…",
    saving: "Salvando…",
    close: "Fechar",
    show: "Mostrar",
    hide: "Ocultar",

    badgeConnected: "Conectada",
    badgeError: "Erro de validação",
    badgePending: "Sem validar",
    badgeOnSend: "Verifica-se ao enviar",

    edit: "Editar",
    remove: "Remover",
    addAccount: "Adicionar conta",

    appliesWhole: "Anúncio inteiro:",
    appliesUnits: "Unidades:",
    noUnits: "Nenhuma unidade a usa",
    allUnits: "Todas as unidades ({count})",
    moreUnits: "+{count} mais",
    andMore: "e mais {count}",
    withoutAccountTitle: "Sem conta:",

    scopeTitle: "A quais unidades se aplica?",
    scopeWhole: "Anúncio inteiro",
    scopeWholeHint: "É usada pelas unidades que não têm outra conta.",
    scopeWholeTaken: "«{name}» já é.",
    scopeUnits: "Só algumas unidades",
    scopeUnitsHint: "Você escolhe quais.",
    unitNow: "agora: {name}",
    unitNowWhole: "agora: a do anúncio inteiro",
    unitNowNone: "sem conta",
    leftToWhole: "ao salvar, a comunicação passa a ser feita com a conta do anúncio inteiro «{name}».",

    aliasLabel: "Nome da conta (opcional)",
    aliasPlaceholder: "Ex.: Torre norte, Apartamento 301",
    loginFrom: "Usar o acesso de",
    secretKeep: "Deixe vazio para não alterar",

    errUnits: "Escolha pelo menos uma unidade.",
    errDefaultExists: "Este anúncio já tem uma conta para todas as suas unidades.",
    errDuplicate: "Você já tem essa conta neste anúncio. Edite-a e adicione unidades.",
    errCopyFrom: "Não foi possível usar o acesso dessa conta. Escreva-o manualmente.",
    errNoListing: "Não encontramos o anúncio. Abra a tela novamente.",
    saveError: "Não foi possível salvar a conta.",

    removeTitle: "Remover esta conta?",
    removeConfirm: "Sim, remover",
    removeNoUnits: "A conta «{name}» será removida. Nenhuma unidade a está usando.",
    removeToFallback: "«{name}» será removida. As unidades que a usam ({units}) passarão a comunicar com a conta do anúncio inteiro «{fallback}».",
    removeToNothing: "«{name}» será removida. As unidades que a usam ({units}) ficarão sem conta e deixarão de informar ao {authority}.",
    removed: "Conta removida.",
    removeError: "Não foi possível remover a conta.",

    sire: {
      name: "SIRE",
      subtitle: "Sistema de Información para el Registro de Extranjeros — Migración Colombia",
      intro: "Cada unidade informa seus hóspedes ao SIRE com uma conta. Você pode usar uma só para o anúncio inteiro ou colocar uma diferente em algumas unidades, por exemplo se cada apartamento está cadastrado com seu próprio código de estabelecimento.",
      introSingle: "Conecte a conta com a qual este anúncio informa seus hóspedes ao SIRE.",
      emptyList: "Você ainda não conectou nenhuma conta do SIRE.",
      withoutAccountText: "Seus check-ins não são informados ao SIRE.",
      newTitle: "Nova conta do SIRE",
      editTitle: "Editar conta do SIRE",
      modalSub: "São os dados com os quais você entra no SIRE",
      defaultName: "Estabelecimento {code}",
      defaultNameDoc: "Documento {document}",
      docTypeLabel: "Tipo de documento",
      docType_CO_ID: "Documento de identidade (cédula de ciudadanía)",
      docType_CO_FID: "Documento de identidade de estrangeiro (cédula de extranjería)",
      documentLabel: "Número do documento",
      documentPlaceholder: "Ex.: 1012345678",
      documentHint: "É o usuário com o qual você entra no SIRE.",
      passwordLabel: "Senha",
      passwordPlaceholder: "A senha do SIRE",
      passwordShared: "Outras contas do anúncio usam este documento ({count}): se você alterar a senha, ela é atualizada em todas.",
      estLabel: "Código de estabelecimento (opcional)",
      estPlaceholder: "Ex.: 67890",
      estHint: "Só é necessário se com o mesmo acesso você informa vários alojamentos. Se ficar vazio, usa-se o que você tem cadastrado.",
      loginTitle: "Acesso ao SIRE",
      loginSame: "O mesmo documento e senha",
      loginSameHint: "Você só escreve o código desta conta.",
      loginOwn: "Outro documento e senha",
      aliasHint: "Serve apenas para reconhecê-la aqui. Se ficar vazio, ela é mostrada pelo código do estabelecimento.",
      metaDoc: "Documento",
      metaEst: "Estabelecimento",
      leftWithout: "sem conta ao salvar. Seus check-ins deixarão de ser informados ao SIRE.",
      errDocument: "Escreva o número do documento.",
      errPassword: "Escreva a senha do SIRE.",
      errPasswordNeeded: "Escreva a senha do novo documento.",
      savedValidated: "Conta salva e validada pelo SIRE.",
      savedNotValidated: "Salva, mas o SIRE não aceita os dados. Revise-os.",
      savedUnchecked: "Conta guardada. O TRA não permite verificar o token antecipadamente: saber-se-á no primeiro envio.",
    },

    tra: {
      name: "TRA",
      subtitle: "Registro de turistas alojados — Ministerio de Comercio, Industria y Turismo",
      intro: "Cada unidade envia seu relatório ao TRA com uma conta. Você pode usar uma só para o anúncio inteiro ou colocar uma diferente em algumas unidades: cada RNT identifica um alojamento.",
      introSingle: "Conecte a conta com a qual este anúncio envia seu relatório ao TRA.",
      emptyList: "Você ainda não conectou nenhuma conta do TRA.",
      withoutAccountText: "Suas estadias não são informadas ao TRA.",
      newTitle: "Nova conta do TRA",
      editTitle: "Editar conta do TRA",
      modalSub: "São o token e o RNT deste alojamento",
      defaultName: "RNT {rnt}",
      tokenLabel: "Token",
      tokenPlaceholder: "Cole seu token aqui",
      tokenHint: "Você o gera em",
      loginTitle: "Acesso ao TRA",
      loginSame: "O mesmo token",
      loginSameHint: "Você só escreve o RNT desta conta.",
      loginOwn: "Outro token",
      rntLabel: "RNT",
      rntPlaceholder: "Ex.: 123456",
      rntHint: "O Registro Nacional de Turismo deste alojamento. É o que identifica o estabelecimento perante o TRA.",
      aliasHint: "Serve apenas para reconhecê-la aqui. Se ficar vazio, ela é mostrada pelo seu RNT.",
      metaRnt: "RNT",
      metaToken: "Token",
      leftWithout: "sem conta ao salvar. Suas estadias deixarão de ser informadas ao TRA.",
      errToken: "Cole o token do TRA.",
      errRnt: "O RNT é um número. Revise-o.",
      savedValidated: "Conta salva e validada pelo TRA.",
      savedNotValidated: "Salva, mas o TRA não aceita os dados. Revise-os.",
      savedUnchecked: "Conta guardada. O TRA não permite verificar o token antecipadamente: saber-se-á no primeiro envio.",
    },

    foreign: {
      ses: "SES Hospedajes (Espanha)",
      colombia: "SIRE e TRA (Colômbia)",
      title: "Ainda há contas de {name}",
      text: "Este anúncio já não é desse país, então essa conta não informa nada. | Este anúncio já não é desse país, então essas {count} contas não informam nada.",
      remove: "Removê-las",
      removeTitle: "Remover as contas que sobraram?",
      removeMessage: "Será removida a conta de {name} que sobrou de antes. Não afeta a autoridade que você usa agora. | Serão removidas as {count} contas de {name} que sobraram de antes. Não afeta a autoridade que você usa agora.",
      removed: "Contas removidas.",
      removeError: "Não foi possível removê-las.",
    },
  },

  // CheckoutMessage.vue
  checkoutMsg: {
    title: "Mensagem de check-out",
    subtitle: "Um lembrete de check-out enviado na noite anterior à saída. Escreva seu próprio texto e use as variáveis disponíveis.",
    loading: "Carregando…",
    enableTitle: "Enviar mensagem de check-out",
    enableSub: "Será enviada automaticamente {day} às {time}.",
    dayLast: "no dia da saída",
    dayBefore: "no dia anterior à saída",
    cloneTitleNoun: "mensagem de check-out",
    cloneItemNoun: "a mensagem de check-out",
    whenLabel: "Quando é enviada",
    dayBeforeShort: "Dia anterior",
    dayLastShort: "Dia da saída",
    atLabel: "Às",
    timeHint: "No dia da saída, o horário não pode ser posterior ao check-out ({time}).",
    otaTitle: "Enviar também via OTA",
    textLabel: "Texto da mensagem de check-out",
    translate: "Traduzir",
    translating: "Traduzindo…",
    attach: "Anexar",
    uploading: "Enviando…",
    attachTitle: "Anexos da mensagem de check-out",
    emojis: "Emojis",
    searchEmoji: "Buscar emoji…",
    variables: "Variáveis",
    varsHint: "Toque para inseri-las. Elas são substituídas pelos dados reais da reserva no envio.",
    uploadDone: "Enviado. Salvando no servidor…",
    attachLimits: "Imagens e PDF até {file} MB · vídeos MP4 até {video} MB.",
    attachLimitsWhy: "Esses são os limites permitidos pelo WhatsApp.",
    tipBefore: "Use",
    tipTextWord: "texto",
    tipMid: "para deixar algo",
    tipBoldWord: "em negrito",
    tipAfter: "(formatação do WhatsApp). O hóspede recebe a mensagem no idioma dele, se configurado.",
    attachShared: "Anexos · compartilhados entre todos os idiomas",
    delete: "Excluir",
    autosaveNote: "As alterações são salvas automaticamente.",
    preview: "Prévia",
    online: "online",
    previewHint: "Atualiza com suas configurações",
    dayOfCheckout: "Dia da saída",
    eveOfCheckout: "Véspera da saída",
    yourAccommodation: "sua acomodação",
    uploadSent: "{sent} de {total} MB",
    filesCount: "{count} arquivos",
    placeholder: "ex.: Olá {guest} 👋 Sua estadia em {property} termina amanhã. O horário de check-out é {time}. Obrigado pela visita!",
    varGuestName: "Nome do hóspede",
    varPropertyName: "Nome da acomodação",
    varCheckoutTime: "Horário de check-out",
    today: "hoje",
    tomorrow: "amanhã",
    previewDefault: "Olá, *{guest}* 👋\n\nÉ só um lembrete de que sua estadia em *{property}* termina {when}.\n\n🕚 O horário máximo de check-out é *{time}*.\n\nMuito obrigado pela sua estadia. Boa viagem! 😊",
    errVideoFormat: "❌ {name} é um vídeo {ext} e o WhatsApp só suporta MP4. Converta para MP4 e envie novamente.",
    errFileSize: "❌ {name} tem {size} MB e o máximo é {max} MB. ",
    errFileSizeVideo: "O WhatsApp não suporta vídeos maiores: comprima ou corte o vídeo.",
    errFileSizeFile: "O WhatsApp não suporta arquivos maiores.",
    attachUploaded: "Anexo(s) enviado(s) com sucesso",
    attachUploadError: "Erro ao enviar anexos",
    attachDeleted: "Anexo excluído",
    attachDeleteError: "Não foi possível excluir o anexo",
    loadError: "Não foi possível carregar a mensagem de check-out.",
    translateEmpty: "Escreva a mensagem no idioma ativo antes de traduzir.",
    translateSuccess: "{count} idiomas traduzidos! Verifique cada aba.",
    translatePartial: "{ok} traduzidos, {fail} falharam.",
    translateError: "Não foi possível traduzir. Tente novamente.",
    saved: "Mensagem de check-out salva",
    saveError: "Não foi possível salvar a mensagem de check-out.",
  },
};
